// extracted by mini-css-extract-plugin
export default {"container":"PagesContainer_container__ckUIA","rightWrapper":"PagesContainer_rightWrapper__O65iY","contentWrapper":"PagesContainer_contentWrapper__5AOao"};